import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";

 const BASE_URL = process.env.REACT_APP_BASE_URL;


export const createEventInCalender = createAsyncThunk(
    "createEventInCalender",
    async (EventData, { rejectWithValue }) => {
        console.log(EventData)
        try {
            const response = await axios.post(`${BASE_URL}/api/v1/Calender/createEvent-InCalender`, EventData);
            console.log("response---------->", response);
            toast.success("Event added successfully", toast_config);
            return response
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to add Event", toast_config); 
            return rejectWithValue(error);
      
        }
    }
);

export const ShowVendorCalenderEvents = createAsyncThunk(
    "ShowVendorCalenderEvents",
    async (ID, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/api/v1/Calender/show-vendor-Events/${ID}`);
            console.log("response data:", response.data.data);
            return response.data.data;  // Make sure to return the correct part of the response data
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to fetch events", toast_config);
            return rejectWithValue(error.response?.data?.message || "Failed to fetch events");
        }
    }
);




const CalenderSlice = createSlice({
    name: 'CalenderSlice',
    initialState: {
        Data: [],
        IsAdding: false,
        loading: false,
        error: null,
        
    },
    reducers: {
        IsAddingOpen: (state, action) => {
            state.IsAdding = true;
        },
        IsAddingClose: (state, action) => {
            state.IsAdding = false;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(createEventInCalender.pending, (state) => {
                state.loading = true;
            })
            .addCase(createEventInCalender.fulfilled, (state, action) => {
                state.loading = false;
              
            })



            .addCase(ShowVendorCalenderEvents.pending, (state) => {
                state.loading = true;
            })
            .addCase(ShowVendorCalenderEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.Data = action.payload.events

            })



            .addMatcher(
                (action) => action.type.endsWith('/rejected') && action.meta.rejectedWithValue,
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload.message; 
                }
            );
    },
});

export const { IsAddingOpen} = CalenderSlice.actions;
export default CalenderSlice.reducer;



 